/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* schermen.module.ts
* 14-2-2020 - Jelmer Jellema - Spin in het Web B.V.
*
* Voegt de schermmodules samen, om de hierarchie in stand te houden
*/

import {NgModule} from '@angular/core';
import {GebruikersModule} from './gebruikers/gebruikers.module';
import {MensenModule} from './mensen/mensen.module';
import {ProjectModule} from './project/project.module';
import {PlanbordModule} from './planbord/planbord.module';
import {WerkbonnenModule} from './werkbonnen/werkbonnen.module';
import {LeveranciersModule} from './leveranciers/leveranciers.module';
import {ExactloglijstModule} from './exact/exactloglijst.module';
import {BamimportSchermModule} from './bamimport/bam-import.module';
import {TotaalexportschermModule} from './totaalexport/totaalexport.module';
import {Filtertoolscherm} from './filtertool/filtertool'; // side-effect import: registreert Filtertoolscherm
import {Toolboxlijst} from './toolbox/toolboxlijst'; // side-effect import: registreert Toolboxlijst
import {Toolboxedit} from './toolbox/toolboxedit'; // side-effect import: registreert Toolboxedit

const submodules = [
  GebruikersModule,
  MensenModule,
  ProjectModule,
  PlanbordModule,
  WerkbonnenModule,
  LeveranciersModule,
  ExactloglijstModule,
  BamimportSchermModule,
  TotaalexportschermModule,
  Filtertoolscherm,
  Toolboxlijst,
  Toolboxedit
];

@NgModule({
  imports: submodules,
  exports: submodules,
}) export class SchermenModule {}
